import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const InputFileContainer = styled.div``;

export const InputFileLabel = styled.label``;

export const InputFileField = styled.input`
  border: 0;
  outline: 0;
  height: 0;
  width: 0;
  opacity: 0; 
`;

export const InputFileContent = styled.div`
  width: 100%;
  border: 1px dashed ${colors.textSecondary};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 40px 0;
  border-radius: 8px;
  background: ${prop => prop.canAddFile ? colors.white : colors.textExGrayLight};
  cursor: ${prop => prop.canAddFile ? 'pointer' : 'initial'};
`;

export const InputFileDescription = styled.p`
  color: #2A2C31;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.03em;
  margin-top: 16px;
`;
